import { getCurrentYearAndMonth } from "utils/date";
import { nonCompliantPatientAction } from "../actions/nonCompliantPatientAction";

import { createSlice } from "@reduxjs/toolkit";

const { currentYear, currentMonth } = getCurrentYearAndMonth();

export const initialState = {
  accountFilter: "all",
  account: "all",
  patient: {},
  showReminderHistoryDrawer: false,
  year: currentMonth === 0 ? currentYear - 1 : currentYear,
  month: currentMonth === 0 ? 12 : currentMonth,
  scheduleType: "Day 31",
  noShowType: "all",
  showUnenrollModal: false,
  showEnrollModal: false,
  activeTab: "",
  subscription: "all",
  showDownloadOverdueModal: false,
};

const nonCompliantPatientSlice = createSlice({
  name: "nonCompliantPatient",
  initialState: initialState,
  reducers: nonCompliantPatientAction,
});

export const {
  setReminderHistoryDrawer,
  setFilter,
  toggleUnenrollModal,
  changeActiveTab,
  toggleEnrollModal,
  toggleDownloadOverduePatientModal,
  setReminderHistoryPatient,
} = nonCompliantPatientSlice.actions;

export default nonCompliantPatientSlice.reducer;
